import actions from '@ehi/global-marketing-interface/lib/actions';

export const upgradeCarClass = (carClassCode) => (dispatch) =>
  dispatch(actions.reservations.upgradeCarClass(carClassCode));
